module.exports = __webpack_public_path__ + "static/img/1.e5dcd58.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/new/1.jpg
// module id = wl7a
// module chunks = 1